import { IonCard, IonCardContent, IonCol, IonGrid, IonRow } from "@ionic/react";
import { PropsWithChildren, useEffect } from "react";
import { QRCode } from 'react-qrcode-logo';
import useDarkMode from "../../hooks/useDarkMode";

interface StellarPayQRModalProps extends PropsWithChildren {
    qrValue: string;
}

const StellarPayQRModal: React.FC<StellarPayQRModalProps> = ({ qrValue }) => {

    const { darkMode } = useDarkMode();

    useEffect(()=>{
        
    },[qrValue])

   

    return (

        <IonGrid>
            <IonRow>
                <IonCol>
                    <IonCard style={{backgroundColor:"#ffffff"}} >
                        <IonCardContent>
                            <QRCode
                                value={qrValue}
                                qrStyle='fluid'
                                bgColor="transparent"
                                fgColor="#04394F"
                                quietZone={20}
                                size={250}
                            />
                        </IonCardContent>
                    </IonCard>
                </IonCol>

            </IonRow>
        </IonGrid>
    )
}

export default StellarPayQRModal